import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MDButton from "components/MDButton";

interface LookupTable {
  key: string;
  name: string;
  description: string;
  route: string;
}

const tables: LookupTable[] = [
  {
    key: "lease-companies",
    name: "Vehicle Lease Companies",
    description: "Lessors a vehicle can be assigned to (Holman, Enterprise, etc.).",
    route: "/admin/lookup-tables/lease-companies",
  },
];

const LookupTablesList = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Lookup Tables
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 2 }}>
        {tables.map((t) => (
          <Card key={t.key} sx={{ p: 2 }}>
            <Typography variant="h6">{t.name}</Typography>
            <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
              {t.description}
            </Typography>
            <MDButton variant="contained" color="primary" onClick={() => navigate(t.route)}>
              Manage
            </MDButton>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default LookupTablesList;
